// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__3yAW7"};